// getters
export const VIS_DATA_LOADED = 'visDataLoaded'
export const VIS_ERROR_OCCURED = 'visErrorOccured'
export const REPORT_LOADING = 'reportLoading'
export const EXCEL_LOADING = 'excelLoading'
export const PDF_LOADING = 'pdfLoading'
export const REPORT_ERROR = 'reportError'
export const NO_DATA_ERROR = 'noDataError'
export const NET_RCLM_SINCE_INCP = 'netRclmSinceIncp'
export const NET_RCLM_YTD = 'netRclmYTD'
export const NET_RCLM_PROCESSING = 'netRclmProcessing'
export const NET_RCLM_FILED = 'netReclaimFiled'
export const NUM_ACTIVE_ACCTS = 'numActiveAccts'
export const NUM_ACTIVE_TRANSACTIONS = 'numActiveTransactions'
export const NUM_PAID_ACCTS = 'numPaidAccts'
export const NUM_PAID_TRANSACTIONS = 'numPaidTransactions'
export const NUM_EVENTS = 'numEvents'
export const PAID_SINCE_INCP = 'paidSinceIncp'
export const PAID_YTD = 'paidYTD'
export const MIDAS_STATUS_GROUPS = 'midasStatusGroups'
export const PAID_BY_YEAR_GROUPS = 'paidByYearGroups'
export const CLIENT_STATUS_GROUPS = 'clientStatusGroups'
export const COUNTRY_GROUPS = 'countryGroups'
export const FI_ACCT_GROUPS = 'fiAcctGroups'

// mutations
// export const SET_FILTER = 'setFilter'
export const SET_VIS_DATA = 'setVisData'
export const SET_LF_API_URL = 'setLfApiUrl'
export const SET_VIS_DATA_LOADED = 'setVisDataLoaded'
export const SET_VIS_ERROR_OCCURED = 'setVisErrorOccured'
export const SET_REPORT_ERROR = 'setReportError'
export const SET_REPORT_LOADING = 'setReportLoading'
export const SET_EXCEL_LOADING = 'setExcelLoading'
export const SET_PDF_LOADING = 'setPdfLoading'
export const SET_NO_DATA_ERROR = 'setNoDataError'
export const SET_FILTER_STACK = 'setFilterStack'

// actions
export const UPDATE_FILTER = 'updateFilter'
export const UPDATE_FILTER_STACK = 'updateFilterStack'
export const DOWNLOAD_EXCEL_FILE = 'downloadExcel'
export const DOWNLOAD_DASHBOARD_PDF = 'downloadDashboardPdf'
export const ACKNOWLEDGE_ERRORS = 'acknowledgeErrors'
